"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedNavigationButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const DownChevronIcon_1 = require("../../icons/DownChevronIcon");
const UpChevronIcon_1 = require("../../icons/UpChevronIcon");
const FeedNavigationButtons_module_css_1 = __importDefault(require("./FeedNavigationButtons.module.css"));
var NavigationDirection;
(function (NavigationDirection) {
    NavigationDirection["UP"] = "UP";
    NavigationDirection["DOWN"] = "DOWN";
})(NavigationDirection || (NavigationDirection = {}));
/**
 * Standard chevron button to navigate a field
 */
function FeedNavigationButtons({ size, onNext, onPrevious, disableNextButton, disablePreviousButton, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: FeedNavigationButtons_module_css_1.default.container, children: [(0, jsx_runtime_1.jsx)(FeedNavigationButton, { disabled: disablePreviousButton, direction: NavigationDirection.UP, size: size, onClick: onPrevious }), (0, jsx_runtime_1.jsx)(FeedNavigationButton, { disabled: disableNextButton, direction: NavigationDirection.DOWN, size: size, onClick: onNext })] }));
}
exports.FeedNavigationButtons = FeedNavigationButtons;
function ChevronIcon({ direction, size }) {
    return direction === NavigationDirection.UP ? ((0, jsx_runtime_1.jsx)(UpChevronIcon_1.UpChevronIcon, { size: size })) : ((0, jsx_runtime_1.jsx)(DownChevronIcon_1.DownChevronIcon, { size: size }));
}
function FeedNavigationButton({ size, direction, onClick, disabled, }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(FeedNavigationButtons_module_css_1.default.btnContainer, {
            [FeedNavigationButtons_module_css_1.default.buttonUp]: direction === NavigationDirection.UP,
            [FeedNavigationButtons_module_css_1.default.buttonDown]: direction === NavigationDirection.DOWN,
            [FeedNavigationButtons_module_css_1.default.disabledBtn]: disabled,
        }), onClick: onClick, role: "button", children: (0, jsx_runtime_1.jsx)(ChevronIcon, { direction: direction, size: size }) }));
}
//# sourceMappingURL=FeedNavigatonButtons.js.map